import { create } from 'zustand';

interface UIStore {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (isOpen: boolean) => void;
  isLocked: boolean;
  setLocked: (locked: boolean) => void;
}

export const useUIStore = create<UIStore>((set) => ({
  isSidebarOpen: true,
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  setSidebarOpen: (isOpen: boolean) => set({ isSidebarOpen: isOpen }),
  isLocked: typeof window !== 'undefined' && localStorage.getItem('pos_screen_locked') === 'true',
  setLocked: (locked: boolean) => {
    if (locked) {
      localStorage.setItem('pos_screen_locked', 'true');
    } else {
      localStorage.removeItem('pos_screen_locked');
    }
    set({ isLocked: locked });
  },
}));
